import useAnalytics from "hooks/useAnalytics";

import { ANALYTICS } from "./constants";

const useUserRolesListAnalytics = () => {
  return useAnalytics({
    page: ANALYTICS.analyticsPage,
  });
};

export default useUserRolesListAnalytics;
